<template>
    <div v-if="bannerList.length != 0">
        <Header :menus="menus"></Header>

        <div class="page-section">
            <RightLian />
            <!-- <div class="banner">
    
        <img src="../assets/about-banner.png" alt="" />
      </div>-->

            <el-carousel
                class="banner"
                indicator-position="inside"
                v-if="bannerList.length != 0"
            >
                <el-carousel-item
                    v-for="(item, index) in bannerList"
                    :key="index"
                >
                    <img class="img2" :src="item" />
                </el-carousel-item>
            </el-carousel>
            <div>
                <div class="fang">
                    <p class="lianXi">联系方式</p>

                    <div class="fangDiv">
                        <div>
                            <p class="spanWen">
                                <i class="el-icon-phone" />
                                <span>18665393712</span>
                            </p>

                            <p class="spanWen">
                                <i class="el-icon-message" />
                                <span>yangyang@wif.ink</span>
                            </p>
                            <p class="spanWen">
                                <i class="el-icon-location-outline" /><span
                                    >深圳市前海深港合作区前湾一路1号A栋201室</span
                                >
                            </p>
                        </div>
                    </div>
                </div>
                <div style="float: left; width: 45%">
                    <baidu-map
                        style="width: 99%; height: 410px"
                        :center="{
                            lng: 113.90979903965428,
                            lat: 22.52108302050473
                        }"
                        :zoom="14"
                    >
                    </baidu-map>
                </div>
            </div>

            <div></div>
            <!--  <div class="container container-wif">
        <ul class="wif-top">
          <li class="wif-top-item">
            <p class="wif-top-item-num">10000+</p>
            <p class="wif-top-item-text">企业用户和开发者</p>
          </li>
          <li class="wif-top-item">
            <p class="wif-top-item-num">500+</p>
            <p class="wif-top-item-text">每日订单量</p>
          </li>
          <li class="wif-top-item">
            <p class="wif-top-item-num">2021</p>
            <p class="wif-top-item-text">成立</p>
          </li>
        </ul>
        <div class="wif -content">
          <div class="wif-title">网飞物联 | WIF</div>
          <div class="split"></div>
          <div class="wif-text">
            <p>
              网飞物联科技有限公司，简称网飞物联。公司专注于物联网触控显示设备、物联网操作系统及设备管控服务平台等产品研发，是集研发、生产、营销、售后服务于一体的技术导向型企业。
            </p>

            <p>
              设备管控服务平台采用了云原生架构，以设备管理、应用管理、运维监控及大数据分析为平台核心，提供友好的操作页面。为企业解决物联网专用设备在运行期间的远程运维和监控工作，让用户足不出户轻松管理海量设备并监控设备的运行稳定性、连续性、健康度等。大大提高了设备管理运维效率和成本管理的水平。
            </p>

            <p>
              公司产品在智能城市、智能物流等多个项目中，为客户的产品和服务赋能。同时，公司拥有专业团队积极推进物联网产品及平台在其他应用场景的应用，积极帮助企业进行“互联网+”的转型，促进产业升级。
            </p>

            <p>
              网飞物联秉承“让复杂的物联网变的更加贴心和更有问题”的核心理念，积极促进研发成果转化，为客户创造价值，用服务感动上帝。
            </p>
          </div>
          <div class="wif-imgList">
            <img src="../assets/about1.png" class="imgshang" alt="" />
            <img src="../assets/about2.png" class="imgshang" alt="" />
            <img src="../assets/about3.png" class="imgxia" alt="" />
          </div>
          <div class="imgXian" style="margin-top: 10px">
            <img src="../assets/about3.png" alt="" />
          </div>
        </div>
      </div>-->

            <div class="container container-art">
                <div class="container-wrap">
                    <div class="art-title">企业文化</div>
                    <p class="split"></p>
                    <ul class="art-content">
                        <li class="art-item">
                            <!-- eslint-disable-next-line max-len -->
                            <img
                                src="data:image/png;base64,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"
                                alt=""
                            />
                            <!--eslint-disable-next-line-->
                            <div>
                                <p class="art-item-title">公司愿景</p>
                                <p class="art-item-text">
                                    致力成为世界上一体化服务商
                                </p>
                            </div>
                        </li>
                        <li class="art-item">
                            <!-- eslint-disable-next-line max-len -->
                            <img
                                src="data:image/png;base64,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"
                                alt=""
                            />
                            <!-- eslint-disable-next-line max-len -->
                            <div>
                                <p class="art-item-title">公司使命</p>
                                <p class="art-item-text">
                                    用物联网技术和人工智能技术让生活更简单
                                </p>
                            </div>
                        </li>
                        <div class="art-item">
                            <!-- eslint-disable-next-line max-len -->
                            <img
                                src="data:image/png;base64,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"
                                alt=""
                            />

                            <div>
                                <p class="art-item-title">价值观</p>
                                <p class="art-item-text">
                                    靠谱的产品、靠谱的团队、<br />靠谱的服务、靠谱的技术
                                </p>
                            </div>
                        </div>
                    </ul>
                </div>
            </div>

            <!--  <div class="container container-map">
        <div class="container-wrap">
          <div class="c-title">联系我们</div>
          <div class="split"></div>
          <div class="map-content">
            <div class="map-content-top">
              <div class="map-left">
                <div>
                  <p class="map-left-title">公司总部</p>
                  <p>
                    深圳市前海深港合作区前湾一路1号A栋201室<br />
                    (入驻深圳市前海商务秘书有限公司)
                  </p>
                </div>
                <div style="margin-top: 40px">
                  <p class="map-left-title">郑州研发中心</p>
                  <p>郑州市中原区大学科技园（东区）1号楼A栋4楼</p>
                </div>
              </div>
              <baidu-map
                class="map-right"
                :center="{ lng: 116.404, lat: 39.915 }"
                :zoom="14"
              >
              </baidu-map>
            </div>
            <div class="map-content-bottom">
              <span>联系电话：18665393712</span>
              <span>电子邮箱：yangyang@wif.ink</span>
            </div>
          </div>
        </div>
      </div>-->
        </div>

        <Footer></Footer>
    </div>
</template>
<script>
import { Footer, Header } from "@components";
// Icz45uIFywWNxDW1ctDqXqrTtCk1vipn
import RightLian from "../components/lianXi/rightLian";

export default {
    name: "About",
    components: {
        Header,
        Footer,
        RightLian
    },
    data() {
        return {
            bannerList: [],

            menus: [
                {
                    text: "首页",
                    id: "app"
                },
                {
                    text: "产品中心",
                    id: "products"
                },

                {
                    text: "联系我们",
                    id: "about"
                },
                {
                    text: "管理平台",
                    id: "guanlipt"
                },
                {
                    text: "开发者文档",
                    id: "devdoc"
                }
            ]
        };
    },
    methods: {
        getList() {
            this.axios({
                url: "/index/ad/getList",
                method: "post",
                data: {
                    position_id: "3"
                }
            }).then(res => {
                //    console.log(res.data.data);
                this.bannerList = res.data.data;
            });
        }
    },
    mounted() {
        this.getList();
    }
};
</script>
<style scoped>
::v-deep .el-carousel__container {
    height: 600px;
}
.banner {
    height: 600px;
    width: 100%;
    background-size: cover;
}
.lianXi {
    position: relative;
    top: 50px;
    margin-left: 140px;
    font-size: 26px;
    color: #fff;
}
.spanWen > span {
    margin-left: 20px;
}
.spanWen {
    margin-top: 20px;
}
.fang {
    float: left;
    width: 55%;
    height: 410px;
    background-color: rgb(12, 90, 170);
}
.fangDiv {
    width: 50%;
    margin: 0 auto;
    font-size: 20px;
    color: #fff;
    margin-top: 12%;
}
</style>
<style scoped>
@media screen and (min-width: 1100px) {
    .imgXian {
        display: none;
    }
}
@media screen and (max-width: 1100px) {
    .page-section {
        overflow-y: scroll;
    }
    .imgshang {
        width: 50%;
        height: 400px;
    }
    .imgxia {
        display: none;
    }
}
</style>
